import type { LanguageCode } from './languages'

/** The list with code moved one place up (-1) or down (1); unchanged at an end. */
export function moveLanguage(list: readonly LanguageCode[], code: LanguageCode, by: -1 | 1): LanguageCode[] {
  const out = [...list]
  const i = out.indexOf(code)
  const j = i + by
  if (i < 0 || j < 0 || j >= out.length) return out
  ;[out[i], out[j]] = [out[j]!, out[i]!]
  return out
}

/** The list without code; the last language is never removed. */
export function withoutLanguage(list: readonly LanguageCode[], code: LanguageCode): LanguageCode[] {
  const out = list.filter((c) => c !== code)
  return out.length > 0 ? out : [...list]
}

/** A language's own name, only where it differs from the English one ("English English" otherwise). */
export function nativeIfOther(known: readonly { code: string; name: string; native: string }[], code: string): string | undefined {
  const l = known.find((k) => k.code === code)
  return l && l.native !== l.name ? l.native : undefined
}
